import DollarSignSVG from "../icons/DollarSignSVG";
import type { ProductType } from "../../navigation/types";

/**
 * Product icon shown on an application card. Personal loan uses the dollar-sign
 * vector; the other products use the design-system icon font for now.
 */
export function ProductIcon({ productType }: { productType: ProductType }) {
  switch (productType) {
    case "personal-loan":
      return <DollarSignSVG />;
    case "auto-loan":
      return <span className="narmi-icon-car-outline" aria-hidden="true" />;
    case "credit-card":
      return <span className="narmi-icon-credit-card" aria-hidden="true" />;
    default:
      return <DollarSignSVG />;
  }
}
